var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.capacityCreatePermission)?_c('vs-row',[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('CapacityForm',{attrs:{"dataCapacity":_vm.capacityItem,"isEditActive":false}})],1)]):_c('not-permission')
}
var staticRenderFns = []

export { render, staticRenderFns }